import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { Shield, Lock } from 'lucide-react';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, user, loading } = useUser();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-100 via-primary-50 to-primary-200">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="w-20 h-20 bg-accent-primary/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Lock className="w-10 h-10 text-accent-primary" />
          </div>
          <h1 className="text-3xl font-serif font-bold text-text-primary mb-4">
            Authentication Required
          </h1>
          <p className="text-text-secondary mb-8">
            Please sign in to access this page.
          </p>
          <div className="space-y-4">
            <a
              href={`/login?redirect=${encodeURIComponent(location.pathname)}`}
              className="block btn-primary text-center"
            >
              Sign In
            </a>
            <a
              href="/register"
              className="block btn-secondary text-center"
            >
              Create Account
            </a>
          </div>
        </div>
      </div>
    );
  }

  if (adminOnly && user?.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-100 via-primary-50 to-primary-200">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Shield className="w-10 h-10 text-red-400" />
          </div>
          <h1 className="text-3xl font-serif font-bold text-text-primary mb-4">
            Access Denied
          </h1>
          <p className="text-text-secondary mb-8">
            This page requires administrator privileges. You don't have permission to access this area.
          </p>
          <a
            href="/"
            className="block btn-primary text-center"
          >
            Return to Home
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
